var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Icon, Modal, Popup } from "semantic-ui-react";
var Help = /** @class */ (function (_super) {
    __extends(Help, _super);
    function Help() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Help.prototype.render = function () {
        if (this.props.useModal) {
            return React.createElement(Modal, { trigger: React.createElement(Icon, { name: 'help circle' }), closeIcon: true },
                React.createElement(Modal.Content, null, this.props.children));
        }
        else {
            return React.createElement(Popup, { style: { tableLayout: "fixed", width: "100%" }, trigger: React.createElement(Icon, { name: 'help circle' }), on: 'click', wide: 'very', size: "small" }, this.props.children);
        }
    };
    return Help;
}(React.Component));
export { Help };
//# sourceMappingURL=Help.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/Help.js
// module id = 29
// module chunks = 0